// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","ideaTable":"_2y3VhDyXLuA3578Zk1Xl2A","moreText":"hbYnGelCvooapJ-Gc71LC","blur":"URwtoqwAcW41sibaE47E3","tickerGroup":"_2z0BFcg7trYcubwpSurptr"};